import { render, staticRenderFns } from "./select-assignment-debouce.component.vue?vue&type=template&id=8974555a&"
import script from "./select-assignment-debouce.component.vue?vue&type=script&lang=ts&"
export * from "./select-assignment-debouce.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
